import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import { RequestHistory, RequestFields, RequestExRateClaim, RequestProject, RequestHospital, RequestHospitalName, RequestItemApp, RequestItemForm, RequestUpdatePost, RequestclaimItemByReqId, RequestAddCancel, ResponseDestination, ResponseAddItem, ResponseHistoryItem, ResponseFields, ResponseExRateClaim, ResponseReferenceCurrNode, ResponseProject, ResponseDeleteItem, ResponseCurrencyList, 
  ResponseAddForm, ResponseDeleteForm, ResponseSaveForm, ResponseSaveItem, ResponseHistoryFormId, ResponseBalance, ResponseShowButtonCancel, ResponseRequest, ResponseAddCancel, ResponseSaveCancel, ResponseCancelItemByReqId, ResponseTypeClaim, ResponseCancelHistory, ResponseReimreqNo, ResponseHistoryForm, ResponseEditClaim, ResponseDestinationHeader, ResponseHospital, ResponseHospitalName, ResponseclaimItemApproval, ResponseClaimItemForm, ResponseClaimItemByReqId, ResponseFamilyBalance } from "../dto/claim.dto";

@Injectable()
export class ClaimApi {

  private service: string = '';
  private model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public historyForm(formData): Observable<ResponseHistoryForm> {

    const method: string = 'GET';
    const func: string = 'claimform/history';
    const params: any = {};
    const urlParams: any = formData;
    // const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryForm>(method, url, params, urlParams, body);
  }

  public historyFormById(payload: RequestItemApp): Observable<ResponseHistoryFormId> {
    const method: string = 'GET';
    const func: string = 'claimform/history';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryFormId>(method, url, params, urlParams, body);
  }

  public historyItem(payload: RequestHistory): Observable<ResponseHistoryItem> {
    const method: string = 'GET';
    const func: string = 'claim/history';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryItem>(method, url, params, urlParams, body);
  }

  public addFields(payload: RequestFields): Observable<ResponseFields> {
    const method: string = 'GET';
    const func: string = 'claim/fields';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFields>(method, url, params, urlParams, body);
  }

  public destinationHeader(): Observable<ResponseDestinationHeader> {
    const method: string = 'GET';
    const func: string = 'claim/destination';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDestinationHeader>(method, url, params, urlParams, body);
  }

  public destination(payload: RequestHospital): Observable<ResponseDestination> {
    const method: string = 'GET';
    const func: string = 'claim/destination';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDestination>(method, url, params, urlParams, body);
  }

  public exRate(payload: RequestExRateClaim): Observable<ResponseExRateClaim> {
    const method: string = 'GET';
    const func: string = 'claim/exRate';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseExRateClaim>(method, url, params, urlParams, body);
  }

  public referenceCurrNode(): Observable<ResponseReferenceCurrNode> {
    const method: string = 'GET';
    const func: string = 'claim/referenceCurrNode';
    const params: any = {};
    const urlParams: any = {} ;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReferenceCurrNode>(method, url, params, urlParams, body);
  }
  
  public project(payload: RequestProject): Observable<ResponseProject> {
    const method: string = 'GET';
    const func: string = 'claim/project';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseProject>(method, url, params, urlParams, body);
  }

  public hospital(payload: RequestHospital): Observable<ResponseHospital> {
    const method: string = 'GET';
    const func: string = 'claim/hospital';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHospital>(method, url, params, urlParams, body);
  }

  public typeClaim(payload): Observable<ResponseTypeClaim> {
    const method: string = 'GET';
    const func: string = 'claim/type';
    const params: any = {};
    const urlParams: any = payload ;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeClaim>(method, url, params, urlParams, body);
  }

  addItem(formData): Observable<ResponseAddItem> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claim/add';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddItem>(method, url, params, urlParams, body, contentType);
  }

  saveItem(formData): Observable<ResponseSaveItem> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claim/save';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveItem>(method, url, params, urlParams, body, contentType);
  }

  deleteItem(formData): Observable<ResponseDeleteItem> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claim/delete';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteItem>(method, url, params, urlParams, body, contentType);
  }

  public hospitalName(payload: RequestHospitalName): Observable<ResponseHospitalName> {
    const method: string = 'GET';
    const func: string = 'claim/hospital';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHospitalName>(method, url, params, urlParams, body);
  }

  public claimItemApproval(payload: RequestItemApp): Observable<ResponseclaimItemApproval> {
    const method: string = 'GET';
    const func: string = 'claimform/items';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseclaimItemApproval>(method, url, params, urlParams, body);
  }

  public claimItemForm(payload: RequestItemForm): Observable<ResponseClaimItemForm> {
    const method: string = 'GET';
    const func: string = 'claimform/items';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseClaimItemForm>(method, url, params, urlParams, body);
  }

  public currencyList(): Observable<ResponseCurrencyList> {
    const method: string = 'GET';
    const func: string = 'claimform/currency';
    const params: any = {};
    const urlParams: any = {} ;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCurrencyList>(method, url, params, urlParams, body);
  }

  addForm(formData): Observable<ResponseAddForm> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claimform/add';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddForm>(method, url, params, urlParams, body, contentType);
  }

  saveForm(formData): Observable<ResponseSaveForm> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claimform/save';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveForm>(method, url, params, urlParams, body, contentType);
  }

  deleteForm(formData): Observable<ResponseDeleteForm> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claimform/delete';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteForm>(method, url, params, urlParams, body, contentType);
  }

  public balance(): Observable<ResponseBalance> {
    const method: string = 'GET';
    const func: string = 'claimform/balance';
    const params: any = {};
    const urlParams: any = {} ;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseBalance>(method, url, params, urlParams, body);
  }

  public cancelHistory(payload: RequestItemApp): Observable<ResponseCancelHistory> {
    const method: string = 'GET';
    const func: string = 'claimform/cancelHistory';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCancelHistory>(method, url, params, urlParams, body);
  }

  public cancelHistoryGDB(payload): Observable<any> {
    const method: string = 'GET';
    const model2: string = 'claim';
    const func: string = 'cancelHistory';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, model2, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public calculateAmount(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'claim/calculateAmount';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public updatePost(payload: RequestUpdatePost): Observable<any> {
    const method: string = 'POST';
    const func: string = 'claim/updatePost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public request(payload: RequestItemApp): Observable<ResponseRequest> {
    const method: string = 'GET';
    const func: string = 'claimform/request';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseRequest>(method, url, params, urlParams, body);
  }

  public buttonCancel(payload: RequestItemApp): Observable<ResponseShowButtonCancel> {
    const method: string = 'GET';
    const func: string = 'claimform/buttonCancel';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseShowButtonCancel>(method, url, params, urlParams, body);
  }

  addCancel(payload: RequestAddCancel): Observable<ResponseAddCancel> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claimform/addCancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddCancel>(method, url, params, urlParams, body, contentType);
  }

  saveCancel(payload: RequestAddCancel): Observable<ResponseSaveCancel> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claimform/saveCancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  public claimItemByReqId(payload: RequestclaimItemByReqId): Observable<ResponseClaimItemByReqId> {
    const method: string = 'GET';
    const func: string = 'claimform/claimItemByReqId';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseClaimItemByReqId>(method, url, params, urlParams, body);
  }

  public cancelItemByReqId(payload: RequestItemApp): Observable<ResponseCancelItemByReqId> {
    const method: string = 'GET';
    const func: string = 'claimform/cancelItemByReqId';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCancelItemByReqId>(method, url, params, urlParams, body);
  }

  public reimreqNO(payload: RequestItemApp): Observable<ResponseReimreqNo> {
    const method: string = 'GET';
    const func: string = 'claimform/reimreqNO';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReimreqNo>(method, url, params, urlParams, body);
  }

  public editClaim(payload: RequestItemApp): Observable<ResponseEditClaim> {
    const method: string = 'GET';
    const func: string = 'claimform/editClaim';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseEditClaim>(method, url, params, urlParams, body);
  }

  deleteCancel(payload): Observable<ResponseSaveCancel> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'claimform/deleteCancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  public claimAdditionalInfo(payload): Observable<any> {
    const method: string = 'GET';
    const func: string = 'claimform/claimAdditionalInfo';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public familyBalance(): Observable<ResponseFamilyBalance> {
    const method: string = 'GET';
    const func: string = 'claimform/familyBalance';
    const params: any = {};
    const urlParams: any = {} ;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFamilyBalance>(method, url, params, urlParams, body);
  }

  cancelClaim(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'cancelClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  editReqCancel(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'editReqCancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  close(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'close';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  cancelApproveClaim(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'cancelApproveClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  cancelRejectClaim(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'cancelRejectClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  cancelRequest(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'cancelRequest';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }

  deleteDraftCancel(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'deleteDraftCancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }



  cancelReviseClaim(payload): Observable<any> {
    const method: string = 'POST';
    const model: string = 'claim';
    const func: string = 'cancelReviseClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveCancel>(method, url, params, urlParams, body, contentType);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/claim.api.ts